import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// REF: this is a temporary fix till the new update of react-collapsible
import CollapsibleImport from 'react-collapsible';
import { uniqueId } from '../../lib/uniqueId.js';
var Collapsible = CollapsibleImport.default || CollapsibleImport;

var TsboCollapsible = /*#__PURE__*/function (_Collapsible) {
  _inherits(TsboCollapsible, _Collapsible);

  var _super = _createSuper(TsboCollapsible);

  function TsboCollapsible(props) {
    var _this;

    _classCallCheck(this, TsboCollapsible);

    _this = _super.call(this, props);

    var id = _this.generateId(props.contentOuterClassName || props.contentInnerClassName || props.className); // @ts-ignore:  Property 'contentId' does not exist on type 'TsboCollapsible'.


    _this.contentId = props.contentElementId || "collapsible-content-".concat(id); // @ts-ignore:  Property 'triggerId' does not exist on type 'TsboCollapsible'.

    _this.triggerId = props.triggerElementProps.id || "collapsible-trigger-".concat(id);
    return _this;
  }

  _createClass(TsboCollapsible, [{
    key: "generateId",
    value: function generateId(text) {
      return text ? text.replace(' ', '-').toLowerCase() : uniqueId();
    }
  }]);

  return TsboCollapsible;
}(Collapsible);

export default TsboCollapsible;